import { render } from "./DiscardConfirmationModal.vue?vue&type=template&id=e59b9ce6"
import script from "./DiscardConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DiscardConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__